import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const blueCat = defineConnector({
  identifier: "blueCat",
  name: "BlueCat",
  tagLine: "DNS, DHCP, and IP address management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}/api/v2/sessions`,
        jsonBody: {
          username: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["apiToken"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Prepare your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need an administrator account on your BlueCat Address Manager with API access. The REST API v2 uses the same credentials as the Address Manager UI.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Address Manager host",
          required: true,
          placeholder: "bam.example.com",
          helperText: "Your BlueCat Address Manager hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v2/sessions`,
  },
});
